import { useMemo } from "react";
import { MAX_SELECTED_RECORDS } from "../selection/tableSelection";
import { RecordTable } from "../blocks/layout/RecordTable";
import { TablePagination } from "../blocks/layout/TablePagination";
import { Loading } from "../elements/Loading";
import { SearchRecord } from "./advancedSearch.types";
import { getResultColumns } from "./searchResultColumns";
import { SearchResultsProps } from "./SearchResults.types";

/** The submitted search's page of results, with its selection, columns and order. */
export function SearchResults({
  search,
  selectable = true,
  scrollable = false,
}: SearchResultsProps) {
  const { submitted, records, total, page, pageSize, loading, selection } = search;

  const columns = useMemo(
    () => (submitted ? getResultColumns(submitted.entityName, submitted.columns) : []),
    [submitted]
  );

  if (!submitted) {
    return null;
  }

  return (
    <div className={scrollable ? "d-flex flex-column flex-grow-1 min-h-0" : undefined}>
      {loading && <Loading />}
      <div
        className={
          loading ? "d-none" : scrollable ? "d-flex flex-column flex-grow-1 min-h-0" : undefined
        }
      >
        <div className={scrollable ? "flex-grow-1 min-h-0 overflow-auto" : undefined}>
        <RecordTable<SearchRecord>
          stickyHeader={scrollable}
          columns={columns}
          rows={records}
          emptyMessage="No records found."
          sortKey={submitted.order.by}
          sortDir={submitted.order.asc ? "asc" : "desc"}
          onSortChange={(by, dir) =>
            search.sortBy({ ...submitted.order, by, asc: dir === "asc" })
          }
          selection={
            selectable
              ? {
                  selectedIds: selection.ids,
                  rowId: (record) => record.Id,
                  onToggleRow: (record) => search.toggleRecord(record.Id),
                  onToggleAll: (_, select) => search.togglePage(select),
                  rowLabel: (record) => record.Name,
                  allSelected: selection.allPages,
                  maxSelected: MAX_SELECTED_RECORDS,
                }
              : undefined
          }
        />
        </div>
        <TablePagination
          total={total}
          page={page}
          pageSize={pageSize}
          onPageChange={search.goToPage}
          onPageSizeChange={search.setPageSize}
        />
      </div>
    </div>
  );
}
